<template>
	<div name="hres87u-popup-approve" id="hres87u-popup-approve" class="modal fade" role="dialog">    
		<div class="modal-dialog modal-lg">
	    <div class="modal-content">
	      <div class="modal-header header-popup">
          <button type="button" class="close" data-dismiss="modal" ref="popupApproveModalButton">&times;</button>
          <h4 class="modal-title">{{ labels['HRES87UC2']['0'] }}</h4>
        </div>

        <div class="modal-body detail detail-responsive">	
        	<div class="detail detail-responsive">
						<div class="clearfix detail-row">
						  <div class="detail-left label-left">{{ labels['HRES87UC2']['10'] }}</div>
						  <div class="detail-right">
						      <div class="detail-text width-70" id="coddesc_codempid" name="desc_codempid">{{ approve.codempid }} - {{ approve.desc_codempid }}</div>
						  </div>
						</div>

						<div class="clearfix detail-row">
						  <div class="detail-left label-left">{{ labels['HRES87UC2']['20'] }}</div>
						  <div class="detail-right">
						      <div class="detail-text width-70" id="approvno" name="approvno">{{ approve.approvno }}</div>
						  </div>
						</div>

						<div class="clearfix detail-row">
						  <div class="detail-left label-left">{{ labels['HRES87UC2']['30'] }}</div>
						  <div class="detail-right">
						      <div class="detail-text width-70" id="coddesc_codappr" name="desc_codappr">{{ approve.codappr }} - {{ approve.desc_codappr }}</div>
						  </div>
						</div>

						<div class="clearfix detail-row">
						  <div class="detail-left label-left">{{ labels['HRES87UC2']['40'] }}</div>
						  <div class="detail-right">
						    <div class="input-group width-70">
                  <hrms-datepicker  v-model="currentDate"
                                    v-show="false"
                                    v-validate="'required|date_format:DD/MM/YYYY'"
                                    data-vv-value-path="inputDate"
                                    name="currentDate"
                                    :has-error="errors.has('currentDate')" />

                  <hrms-datepicker  v-model="approve.dteappr"
                                    v-validate="'required|date_format:DD/MM/YYYY|after:currentDate'"
                                    data-vv-value-path="inputDate"
                                    name="dteappr"
                                    :has-error="errors.has('dteappr')" />
                  <div class="text-error" v-show="errors.has('dteappr')">{{errors.first('dteappr')}}</div>	
						    </div>
						  </div>
						</div>

						<div class="clearfix detail-row">
						  <div class="detail-left label-left">{{ labels['HRES87UC2']['50'] }}</div>
						  <div class="detail-right">
							    <input type="text" class="form-control input-text width-70" id="numexemp" name="numexemp" maxlength="16" v-model="approve.numexemp" />
							</div>
						</div>

						<div class="clearfix detail-row">
						  <div class="detail-left label-left">{{ labels['HRES87UC2']['60'] }}</div>
              <div class="detail-right ">
                  <input type="radio" name="flgblist" v-model="approve.flgblist" value="Y" > <span class="radio-text">{{ labels['HRES87UC2']['70'] }}</span>
                  <input type="radio" name="flgblist" v-model="approve.flgblist" value="N" > <span class="radio-text">{{ labels['HRES87UC2']['80'] }}</span>
              </div>
            </div>
						
						<div class="clearfix detail-row">
						  <div class="detail-left label-left">{{ labels['HRES87UC2']['90'] }}</div>
						  <div class="detail-right">
						    <div class="input-group width-70">
						  		<hrms-dropdown  v-model="approve.flgssm" 
                                  :options="arrFlgssm[nowLang]"
                                  v-validate="indexSelected.flgStaappr === 'A' ? 'required' : ''"
                                  data-vv-value-path="inputValue"
                                  data-vv-name="flgssm"
                                  :has-error="errors.has('flgssm')" />
                  <div class="text-error" v-show="errors.has('flgssm')">{{errors.first('flgssm')}}</div>
						  	</div>
						  </div>
						</div>

						<div class="clearfix detail-row">
						  <div class="detail-left label-left">{{ labels['HRES87UC2']['100'] }}</div>
						  <div class="detail-right">
						      <div class="detail-text width-70" id="status" name="status">{{ approve.status }}</div>
						  </div>
						</div>

						<div class="clearfix detail-row">
						  <div class="detail-left label-left">{{ labels['HRES87UC2']['140'] }}</div>
						  <div class="detail-right">
                  <textarea class="textarea-text width-70" maxlength="500" id="remark" name="remark" 
                            v-model="approve.remark" >
                  </textarea>
                  <div class="remark-limit-character">{{ dispLimitLabel(500) }}</div> 
              </div>
						</div>
	
        	</div>			
        </div>

        <div class="modal-footer align-center border-color-skin">
          <button type="button" class="btn bg-green" @click="validatePopupApprove()" ><i class="fa fa-check-circle"></i> {{ labelsButton['approve'] }}</button>
        </div>

	    </div>
    </div>
	</div>
</template>

<script>
import moment from 'moment'
import { constLabels } from 'assets/js/constLabels.js'

export default {
  name: 'hres87u-popup-approve',
  data () {
    return {
      approve: {
        approvno: 0,
        chk_appr: '',
        numseq: '',
        dtereq: '',
        codempid: '',
        desc_codempid: '',
        dteappr: '',
        dteeffec: '',
        numexemp: '',
        flgblist: 'N',
        flgssm: '',
        remark: '',
        flgwarn: '',
        codappr: '',
        desc_codappr: '',
        staappr: '',
        flgStaappr: '',
        status: ''
      },
      currentDate: moment().format('DD/MM/YYYY')
    }
  },
  created () {
    if (typeof this.arrFlgssm[this.nowLang][this.approve.flgssm] === 'undefined') {
      this.approve.flgssm = ''
    }
  },
  watch: {
    detailSubmit () {
      this.approve = {
        approvno: this.indexSelected.approvno,
        chk_appr: this.indexSelected.chk_appr,
        numseq: this.indexSelected.numseq,
        dtereq: this.indexSelected.dtereq,
        codempid: this.indexSelected.codempid,
        desc_codempid: this.indexSelected.desc_codempid,
        dteappr: moment().format('DD/MM/YYYY'),
        dteeffec: this.indexSelected.dteeffec,
        numexemp: this.detailSubmit.numexemp,
        flgblist: (this.detailSubmit.flgblist !== '') ? this.detailSubmit.flgblist : 'N',
        flgssm: this.detailSubmit.flgssm,
        remark: '',
        flgwarn: '',
        codappr: this.codappr,
        desc_codappr: this.descCodappr,
        staappr: this.indexSelected.staappr,
        flgStaappr: this.indexSelected.flgStaappr,
        status: this.indexSelected.status
      }
      this.$nextTick(function () {
        this.errors.clear()
      })
    }
  },
  props: [ 'labels', 'labelsButton', 'nowLang', 'postHres87uSendApprove', 'indexSelected', 'arrFlgssm', 'codappr', 'descCodappr', 'detailSubmit' ],
  methods: {
    dispLimitLabel (limit) {
      return constLabels('limitTo') + ' ' + limit + ' ' + constLabels('characters')
    },
    validatePopupApprove () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.postHres87uSendApprove(this.sendApprove())
        }
      })
    },
    sendApprove () {
      return {
        approveParams: this.approve,
        referenceButton: this.$refs.popupApproveModalButton
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// popupApprove.vue?0f244bbc